import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Megaphone } from "@phosphor-icons/react";

export default function SponsoredBanner() {
    const [b, setB] = useState(null);
    useEffect(() => {
        api.get("/banners/active").then(({ data }) => {
            if (data && data.banner_id && data.headline) setB(data);
        }).catch(() => {});
    }, []);
    if (!b) return null;
    const Wrap = ({ children }) => b.link
        ? <a href={b.link} target="_blank" rel="noopener noreferrer sponsored" data-testid={`sponsored-${b.banner_id}`}>{children}</a>
        : <div data-testid={`sponsored-${b.banner_id}`}>{children}</div>;
    return (
        <Wrap>
            <div className="mb-4 border border-violet-500/40 bg-gradient-to-r from-violet-500/10 via-violet-500/5 to-transparent rounded-sm p-3 flex items-center gap-3 hover:border-violet-400 transition-colors">
                <span className="text-[9px] uppercase tracking-widest font-mono bg-violet-400 text-slate-950 px-1.5 py-0.5 rounded-sm shrink-0">sponsored</span>
                {b.image_url && <img loading="lazy" decoding="async" src={b.image_url} alt="" className="w-8 h-8 rounded-sm object-cover border border-white/10" />}
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-bold text-violet-200 truncate">{b.headline}</div>
                </div>
                <Megaphone size={14} weight="duotone" className="text-violet-300 shrink-0" />
            </div>
        </Wrap>
    );
}
